import { Capacitor, registerPlugin } from "@capacitor/core";

// Liens https://yalola.app ouverts dans l'app (Android App Links).
// Plugin natif YalolaLinksPlugin.java — absent des binaires antérieurs (mise à jour OTA) :
// dans ce cas getAppLinkState() renvoie { state: "unknown" } et l'interface ne s'affiche pas.
let plugin = null;
const native = () => {
  plugin = plugin || registerPlugin("YalolaLinks");
  return plugin;
};

// Carte « Ouvre les liens Yalola dans l'app » (accueil) : « Plus tard » / « Activer » = pause de 30 jours (jamais
// définitif : un vrai défaut de configuration peut être proposé à nouveau) ; un lien https://yalola.app/… reçu PAR
// l'app = preuve qu'Android route déjà les liens ici → carte masquée 180 jours (rafraîchi à chaque lien reçu),
// même si l'état système est mal remonté (surcouches Xiaomi/HyperOS). Valeurs = horodatage ms (ancien « 1 » ignoré).
const DISMISS_KEY = "yalola.applinks.nudge.dismissed";
const PROOF_KEY = "yalola.applinks.proven_at";
const DAY_MS = 86400000;
export const NUDGE_SNOOZE_MS = 30 * DAY_MS;
export const PROOF_TTL_MS = 180 * DAY_MS;

const readTs = (key) => {
  try { const n = Number(localStorage.getItem(key) || 0); return Number.isFinite(n) && n > 1 ? n : 0; } catch { return 0; }
};
const writeNow = (key) => { try { localStorage.setItem(key, String(Date.now())); } catch { /* noop */ } };

export const appLinksSupported = () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android";

// { state: "verified" | "selected" | "none" | "unsupported" | "unknown", linkHandlingAllowed?: bool }
export const getAppLinkState = async () => {
  if (!appLinksSupported()) return { state: "unknown" };
  try {
    return await native().getState();
  } catch {
    return { state: "unknown" };
  }
};

export const openAppLinkSettings = () => native().openSettings();

// Le plugin surveille l'interrupteur pendant que les réglages sont ouverts : dès qu'il passe au vert, il ramène
// l'app au premier plan et émet « linksEnabled » (état). Renvoie une fonction de désabonnement.
export const onAppLinksEnabled = (cb) => {
  if (!appLinksSupported()) return () => {};
  let handle = null;
  let off = false;
  try {
    Promise.resolve(native().addListener("linksEnabled", (s) => { if (!off) cb(s || {}); }))
      .then((h) => { handle = h; if (off) h?.remove?.(); })
      .catch(() => {});
  } catch { /* vieux binaire sans le plugin */ }
  return () => { off = true; handle?.remove?.(); };
};

// Le lien doit être activé à la main (téléphone qui n'a pas vérifié yalola.app tout seul).
export const appLinksNeedAction = (s) => !!s && (s.state === "none" || (s.state === "selected" && s.linkHandlingAllowed === false));

export const isAppLinksNudgeDismissed = () => Date.now() - readTs(DISMISS_KEY) < NUDGE_SNOOZE_MS;
export const dismissAppLinksNudge = () => writeNow(DISMISS_KEY);

export const isAppLinksProven = () => Date.now() - readTs(PROOF_KEY) < PROOF_TTL_MS;
export const markAppLinksProven = () => writeNow(PROOF_KEY);
// URL qui a ouvert l'app (appUrlOpen / launch URL) : https = App Link routé par Android → preuve. Exclus : yalola://
// (page intermédiaire /api/e) et le retour Stripe /payment/… (intent:// explicite scheme=https, lib/checkout.js).
export const noteAppOpenedByUrl = (url) => {
  const u = String(url || "");
  if (/^https:\/\//i.test(u) && !/^https:\/\/[^/]+\/payment\//i.test(u)) markAppLinksProven();
};

export const shouldShowAppLinksNudge = (state) =>
  appLinksSupported() && appLinksNeedAction(state) && !isAppLinksProven() && !isAppLinksNudgeDismissed();
